// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeAccountDeleteBody = {
  requestId: string;
};

export type typeAccountDeleteOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { isDeleted: boolean; deletedAt: string };
};

export type typeAccountDeleteOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAccountDeleteOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAccountDeleteOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaAccountDeleteBody = {
  type: "object",
  properties: { requestId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["requestId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createAccountDelete(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaAccountDeleteBody);
  }

  return async function postAccountDelete(
    payload: typeAccountDeleteBody,
  ): Promise<typeAccountDeleteOutput200 | typeAccountDeleteOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postAccountDelete" failed before calling the network. #17055e4eaab5`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#17055e4eaab5" },
        },
        data: null,
      } as typeAccountDeleteOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/account/delete`,
      httpMethod: "POST",
      options,
    })) as typeAccountDeleteOutput200 | typeAccountDeleteOutput400;
  };
}
